import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CardVerificationRequest, CardVerificationResponse } from '../interfaces/card-verification';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class CardVerificationService {
  private readonly verifyCardUrl = 'v2/extranet/verify-card';

  constructor(private http: HttpService) {}

  verifyCard(cardNumber: number): Observable<CardVerificationResponse> {
    const request: CardVerificationRequest = { card_number: cardNumber };
    return this.http.post<CardVerificationResponse>(this.verifyCardUrl, request);
  }
}
